import { ClassifiedEmitter } from '../../rest/types/Classified'
import { AdsEmitterBannerProps } from '../../components/AdsEmitterBanner'
import { Configuration } from '../../rest/types/Configuration'
import { EmitterType } from '../../rest/types/api/Classified'

import { ImageTransformer } from './ImageTransformer'

export function ClassifiedEmitterBannerTransformer({
  t,
  emitter,
  configuration,
}: {
  t: any
  emitter: ClassifiedEmitter
  configuration: Configuration
}): AdsEmitterBannerProps | undefined {
  return emitter
    ? {
        name:
          emitter?.name ||
          `${t('ads_emitter_banner_doctor_name', {
            name: emitter?.user?.firstName,
            surname: emitter?.user?.lastName,
          })}`,
        ...(emitter?.type === EmitterType.Doctor && {
          role: emitter?.user?.speciality?.name,
        }),
        smallDescription: emitter?.presentation,
        avatar: {
          photo: emitter?.logo
            ? ImageTransformer(emitter?.logo as any)
            : ImageTransformer(
                (emitter?.user?.avatar as any) ??
                  (configuration.config.defaultAvatar as any)
              ),
        },
        ...(emitter?.website && {
          button: {
            text: t('discover_button_text'),
            href: emitter?.website,
            target: '_blank',
          },
        }),
      }
    : undefined
}
